import { trackPageView } from '../../utils/analytics';
import { switchTab } from '../../utils/tabs';

export const init = ($hpTabs) => {
  const hpTabsButtons = $hpTabs.querySelectorAll('.j-tabs-button');

  hpTabsButtons.forEach((tab) => {
    if (tab.getAttribute('data-state') === 'active') {
      const tabsWrapper = document.querySelector('.j-wrapper');
      tabsWrapper.classList.add(`is-tab-active-${tab.id}`);
    }

    tab.addEventListener('click', (e) => {
      const tabName = tab.querySelector('.j-tabs-section-title').getAttribute('data-shadow');
      trackPageView(tabName);
      if (!e.target.href && !e.target.parentElement.href) {
        switchTab(tab);
      }
    });
  });
};
